import { jsx as t, jsxs as l, Fragment as f } from "react/jsx-runtime";
import A, { useMemo as h } from "react";
import e from "./style.module.less.js";
import L from "./social-fb.svg.js";
import T from "./social-instagram.svg.js";
import _ from "./social-tik-tok.svg.js";
import q from "./social-youtube.svg.js";
import F from "./social-ln.svg.js";
import R from "./logo-white.webp.js";
import { CountryLanguageSelector as E } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as D, canLanguageUseAtticus as x, areasOfLawData as C, withDirectoryCountries as b, directoryBaseData as $ } from "../../../constants.js";
import { convertToKebabCase as v } from "../../../utils/case-conversion.js";
import { getRoute as N, RouteType as k } from "../../../utils/get-route.js";
import M from "../menu/message-animated.svg.js";
import S from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as W } from "../../../context/config-context.js";
const Y = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: L
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: T
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: _
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: F
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: q
  }
], B = () => /* @__PURE__ */ t("div", { className: e.socialContainer, children: Y.map((r) => /* @__PURE__ */ t(
  "a",
  {
    href: r.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": r.name,
    className: e.socialIconContainer,
    children: /* @__PURE__ */ t(r.Icon, { width: 32, height: 32, className: e.socialIcon })
  },
  r.name
)) }), se = (r) => {
  const {
    className: a = "",
    onLanguageChange: m,
    isAuthenticated: o,
    openAuthModal: d,
    language: s = D,
    getTranslation: i,
    isLawyerSupported: y,
    onRequestLawyer: g
  } = r, p = h(() => x(s) ? s : void 0, [s]), I = h(
    () => i("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, s ? `/${s}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      s ? `/${s}/privacy` : "/privacy"
    ),
    [i, s]
  ), n = h(() => s ? C[s] : null, [s]), u = /* @__PURE__ */ t(
    E,
    {
      onLanguageChange: m,
      language: s ?? ""
    }
  ), c = () => /* @__PURE__ */ t(
    "a",
    {
      href: "/account",
      className: `${e.menuItem}`,
      onClick: (w) => {
        o || (w.preventDefault(), d == null || d());
      },
      children: i("pages.account")
    }
  );
  return /* @__PURE__ */ t("footer", { className: `${e.footer} ${a}`, children: /* @__PURE__ */ l("div", { className: e.widthWrapper, children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `${e.logoContainer} ${n != null && n.length ? e.large : ""}`,
        children: [
          /* @__PURE__ */ t("a", { href: s ? `/${s}` : "/", className: e.logo, children: /* @__PURE__ */ t(
            "img",
            {
              src: R,
              width: 202,
              height: 28,
              alt: "LawConnect Logo",
              loading: "lazy",
              className: e.logoImage
            }
          ) }),
          /* @__PURE__ */ t("div", { className: e.headerLanguageSelector, children: u })
        ]
      }
    ),
    n != null && n.length ? /* @__PURE__ */ t("div", { className: `${e.gridContainer} ${e.large}`, children: /* @__PURE__ */ t(
      H,
      {
        language: s,
        accountComponent: /* @__PURE__ */ t(c, {}),
        isLawyerSupported: y,
        onRequestLawyer: p ? g : void 0
      }
    ) }) : /* @__PURE__ */ t("div", { className: e.gridContainer, children: /* @__PURE__ */ t(
      K,
      {
        language: s,
        accountComponent: /* @__PURE__ */ t(c, {}),
        getTranslation: i
      }
    ) }),
    /* @__PURE__ */ l("div", { className: e.bottomBarContainer, children: [
      /* @__PURE__ */ l("div", { className: e.bottomSocialContainer, children: [
        /* @__PURE__ */ t(B, {}),
        /* @__PURE__ */ t("div", { className: e.languageSelectorContainer, children: u })
      ] }),
      /* @__PURE__ */ l("div", { className: e.copyright, children: [
        /* @__PURE__ */ t("div", { children: i("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ l("div", { className: e.copyrightBottom, children: [
          /* @__PURE__ */ l("div", { children: [
            i("auth.copyright-description"),
            " "
          ] }),
          n != null && n.length ? /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: I } }) : null
        ] })
      ] })
    ] })
  ] }) });
}, H = (r) => {
  const { language: a, accountComponent: m, isLawyerSupported: o, onRequestLawyer: d } = r, { diyWill: s } = W(), i = h(() => {
    const n = C[a];
    return b.includes(a) ? [
      ...n,
      {
        title: $.footerTitle ?? "",
        description: $.description,
        image: $.image,
        link: "topics"
      }
    ] : n;
  }, [a]), y = h(() => b.includes(a), [a]), g = o ? 5 : 4, p = h(() => {
    const n = g * 2, u = i.slice(0, n);
    return [u.slice(0, g), u.slice(g)];
  }, [i, g]), I = h(() => [
    {
      header: "Browse",
      items: [
        {
          key: "ask",
          label: "Ask a question",
          href: N(k.NEW_CHAT),
          icon: /* @__PURE__ */ t(S, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.askQuestion}`
        },
        {
          key: "request",
          label: "Request a lawyer",
          href: d ? void 0 : N(k.LAWYER_REQUEST_CHAT),
          icon: /* @__PURE__ */ t(M, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.requestLawyer}`,
          show: !!o,
          onClick: d
        },
        {
          key: "library",
          label: "Areas of law",
          href: `/${a}/topics`,
          className: e.menuItem
        },
        {
          key: "about",
          label: "About",
          href: a ? `/${a}/about` : "/about",
          className: e.menuItem
        },
        {
          key: "for-lawyers",
          label: "For lawyers",
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: e.menuItem
        },
        {
          key: "account",
          node: m,
          show: !o
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: N(k.WILL_INFO),
          className: e.menuItem,
          show: a === "en-us" && s === !0
        },
        {
          key: "insights",
          label: "Insights",
          href: a ? `/${a}/insights` : "/insights",
          className: e.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: a ? `/${a}/faqs` : "/faqs",
          className: e.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: a ? `/${a}/directory` : "/directory",
          className: e.menuItem,
          show: y && !!o
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: e.menuItem,
          show: !o && !(a === "en-us" && s === !0)
        },
        {
          key: "company",
          label: "Company",
          href: a ? `/${a}/about/company` : "/about/company",
          className: e.menuItem,
          show: !o
        },
        {
          key: "contact",
          label: "Contact us",
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: e.menuItem
        },
        {
          key: "account",
          node: m,
          show: !!o
        }
      ]
    },
    {
      header: "Topics",
      items: p[0].map((n) => ({
        key: `area-1-${n.title}`,
        label: n.footerTitle ?? n.title,
        href: n.link === "topics" ? `/${a}/topics` : `/${a}/topics/${n.link ?? v(n.title)}`,
        className: e.menuItem
      }))
    },
    {
      header: "",
      items: p[1].map((n) => ({
        key: `area-2-${n.title}`,
        label: n.footerTitle ?? n.title,
        href: n.link === "topics" ? `/${a}/topics` : `/${a}/topics/${n.link ?? v(n.title)}`,
        className: e.menuItem
      }))
    }
  ], [
    a,
    o,
    y,
    p,
    m,
    s
  ]);
  return /* @__PURE__ */ t(f, { children: I.map((n, u) => /* @__PURE__ */ l("div", { className: e.column, children: [
    /* @__PURE__ */ t("div", { className: e.headerLabel, children: n.header ?? "" }),
    n.items.filter((c) => c.show !== !1).map(
      (c, w) => c.node ? /* @__PURE__ */ t(A.Fragment, { children: c.node }, `${c.key}-${w}`) : /* @__PURE__ */ t(
        "a",
        {
          href: c.href,
          className: c.className ?? e.menuItem,
          onClick: c.onClick,
          children: c.icon ? /* @__PURE__ */ l(f, { children: [
            /* @__PURE__ */ t("span", { className: e.menuItemText, children: c.label }),
            c.icon
          ] }) : /* @__PURE__ */ t(f, { children: c.label })
        },
        c.key
      )
    )
  ] }, u)) });
}, K = (r) => {
  const { language: a, accountComponent: m, getTranslation: o } = r;
  return /* @__PURE__ */ l(f, { children: [
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ l(
        "a",
        {
          href: N(k.NEW_CHAT),
          className: `${e.menuItem} ${e.askQuestion}`,
          children: [
            o("pages.ask-a-question"),
            /* @__PURE__ */ t(S, { className: e.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/about` : "/about",
          className: `${e.menuItem}`,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: `${e.menuItem}`,
          children: o("register.for-lawyers")
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      a.includes("en") ? /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/insights` : "/insights",
          className: `${e.menuItem}`,
          children: o("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/faqs` : "/faqs",
          className: `${e.menuItem}`,
          children: o("pages.faqs")
        }
      ),
      a.includes("en") ? null : /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: `${e.menuItem}`,
          children: o("pages.ai-technology")
        }
      ),
      m
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: `${e.menuItem}`,
          children: o("pages.contact-us")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/terms` : "/terms",
          className: `${e.menuItem}`,
          children: o("pages.terms")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/privacy` : "/privacy",
          className: `${e.menuItem}`,
          children: o("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  se as FooterComponent,
  Y as SOCIAL_MEDIA_LINKS
};
